import data from "../../data/collaboration.json";

export default function CollaborationHighlight() {
  return (
    <section className="bg-gradient-to-b from-white to-gray-50 py-16 sm:py-20 lg:py-24">
      <div className="max-w-7xl mx-auto px-6">

        <div className="text-center mb-14">
          <p className="uppercase tracking-widest text-sm text-indigo-600 font-semibold mb-3">
            Strategic Collaboration
          </p>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0b1b4d]">
            Collaboration with {data.company}
          </h2>

          <p className="mt-4 text-gray-600 max-w-2xl mx-auto">
            Strengthening industry-academic connections to provide real-world exposure and better career pathways.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {data.images.map((img, index) => (
            <div
              key={index}
              className="rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-2xl transition-all duration-300"
            >
              <img
                src={img}
                alt={`Collaboration ${index + 1}`}
                className="w-full h-72 object-cover hover:scale-105 transition-transform duration-500"
              />
            </div>
          ))}
        </div>

        <div className="max-w-3xl mx-auto text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            About the Collaboration
          </h3>

          <p className="text-gray-700 leading-relaxed text-lg">
            {data.description}
          </p>
        </div>

      </div>
    </section>
  );
}
